module.exports = __webpack_public_path__ + "static/media/dub-g_img.4bf9e437.jpg";